import { Button, Table } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';

const MyDocuments = ({ contract, downloadFile, spinLoading }) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t('contracts.my_documents.saved_date'),
      render: (record) => {
        if (record.savedDate && record.history?.length)
          return moment(record.savedDate).format(`DD/MM/YYYY HH:mm`);
        return 'Aucune donnée';
      }
    },
    {
      title: t('contracts.my_documents.saved_by'),
      render: (record) => {
        if (record.savedBy)
          return `${record.savedBy?.first_name} ${record.savedBy?.last_name}`;
        return 'Aucune donnée';
      }
    },
    {
      title: t('contractDocuments.type'),
      render: (record) => (
        <div style={{ whiteSpace: 'normal' }}>
          {`${t(`contractDocuments.${record.name}`)}${
            record.name === 'amendment' ||
            record.name === 'particular_condition_av' ||
            record.name === 'QUOTE_CREATION_AV'
              ? ` ${record.amendment_number}` || ''
              : ''
          }`}
        </div>
      )
    },
    {
      title: t('contractDocuments.files'),
      render: (record) => {
        if (record.files.length === 0) {
          return '';
        }
        return record.files.map((file) => {
          return (
            <p>
              <Button
                loading={spinLoading}
                style={{ marginLeft: -16, whiteSpace: 'normal' }}
                type="link"
                onClick={() => downloadFile(file)}
              >
                <UploadOutlined />
                {`${file.metadata?.originalName}`}
              </Button>
            </p>
          );
        });
      }
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={contract.history_documents
          .filter((f) => f.status !== 'DELETE')
          .sort((a, b) => new Date(b.savedDate) - new Date(a.savedDate))}
      />
    </>
  );
};

MyDocuments.propTypes = {
  spinLoading: PropTypes.bool.isRequired,
  downloadFile: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    history_documents: PropTypes.arrayOf(PropTypes.shape({})),
    effective_date: PropTypes.string
  }).isRequired
};

export default MyDocuments;
